
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleetShowersPolartwilight as ObiLightSleetShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet-showers-polartwilight.js';
 
 
 

 
 export const ObiLightSleetShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-light-sleet-showers-polartwilight',
   elementClass: ObiLightSleetShowersPolartwilightElement,
   events: {
     
   }
  });
 
 